import { render } from "./WorkCatagory.vue?vue&type=template&id=3fb6c9de"
import script from "./WorkCatagory.vue?vue&type=script&lang=js"
export * from "./WorkCatagory.vue?vue&type=script&lang=js"

import "./WorkCatagory.vue?vue&type=style&index=0&id=3fb6c9de&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__